module.exports = "https://static.wanderu.com/static/media/trustpilot-logo.fbafabcb.svg";